import { render } from "./payment-add-modal.vue?vue&type=template&id=0b06a92d&scoped=true"
import script from "./payment-add-modal.vue?vue&type=script&lang=js"
export * from "./payment-add-modal.vue?vue&type=script&lang=js"

import "./payment-add-modal.vue?vue&type=style&index=0&id=0b06a92d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b06a92d"]])

export default __exports__